import { Container, styled } from '@mui/material';

export const DashboardWrapper = styled(Container)`
  display: flex;
  max-width: 1400px !important;
`;
